import Constants from '@/Constants';
import { TagRequest } from '@/models/Tag';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { getSuggestionTagsSuccess, getTagsFailure, getTagsSuccess } from './action';
import { TagTypes } from './types';

export function* getTags(action: PayloadAction<TagTypes.GET_TAGS_REQUEST, TagRequest>) {
    try {
        let tagRequestString: string = `${Constants.TAGS_URI}?applicationId=${action.payload.applicationId}&organizationId=${action.payload.orgId}`;

        if (action.payload.limit) {
            tagRequestString += `&limit=${action.payload.limit}`;
        }
        if (action.payload.name) {
            tagRequestString += `&name=${action.payload.name}`;
        }
        if (action.payload.offset) {
            tagRequestString += `&offset=${action.payload.offset}`;
        }
        if (action.payload.orderBy) {
            tagRequestString += `&orderBy=${action.payload.orderBy}`;
        }

        const { data } = yield call(http.get, tagRequestString);
        if (action.payload.isSuggestion) {
            yield put(getSuggestionTagsSuccess(data));
        } else {
            yield put(getTagsSuccess(data));
        }
    } catch (err) {
        yield put(getTagsFailure(err));
    }
}
